
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideRouter, withHashLocation } from '@angular/router';
import { errorInterceptor } from '@services/security/error.interceptor';
import { httpInterceptor } from '@services/security/http.interceptor';
import { routes } from './app.routes';

// Se registra el locale pero no se toca LOCALE_ID: cambiarlo global reformatearia
// tambien todos los precios de la tienda. Las pantallas que muestran fechas le
// pasan 'es-AR' al pipe.
registerLocaleData(localeEsAr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withHashLocation()),

    importProvidersFrom(
      BrowserAnimationsModule
    ),

    provideHttpClient(withInterceptors([
      httpInterceptor,
      errorInterceptor
    ]))

  ]
};
